"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragablePaper = void 0;
const react_1 = __importDefault(require("react"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const react_draggable_1 = __importDefault(require("react-draggable"));
function DragablePaper(props) {
    return (react_1.default.createElement(react_draggable_1.default, { cancel: '[class*="MuiDialogContent-root"], [class*="MuiDialogActions-root"]' },
        react_1.default.createElement(Paper_1.default, Object.assign({}, props))));
}
exports.DragablePaper = DragablePaper;
//# sourceMappingURL=draggable-paper.js.map